// src/components/RoofingSchema.js
import React from "react";
import { Helmet } from "react-helmet";

const GrandRapidsSchema = () => {
  const jsonLd = {
    "@context": "http://schema.org",
    "@type": "RoofingContractor",
    name: "Roach Home Improvement, LLC",
    url: "https://roachhomeimprovement.com/roofing-grand-rapids-mi/",
    telephone: "+1-269-420-6623",
    email: "office@roachhomeimprovement.com",
    address: {
      "@type": "PostalAddress",
      streetAddress: "4331 Clyde Park Ave SW, Suite ?",
      addressLocality: "Wyoming",
      addressRegion: "MI",
      postalCode: "49509",
      addressCountry: "US",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 42.889902,
      longitude: -85.717680,
    },
    hasMap: "https://www.google.com/maps/place/4331+Clyde+Park+Ave+SW",
    priceRange: "$$$",
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "08:00",
        closes: "17:00",
      },
    ],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "5",
      reviewCount: "271",
    },
    review: [
      {
        "@type": "Review",
        author: { "@type": "Person", name: "Kevin Rabineau" },
        datePublished: "2025-02-28",
        reviewBody: "We suffered significant roof and gutter damage from a storm...",
        reviewRating: {
          "@type": "Rating",
          ratingValue: "5",
          bestRating: "5",
        },
      },
    ],
    areaServed: {
      "@type": "GeoCircle",
      geoMidpoint: {
        "@type": "GeoCoordinates",
        latitude: 42.9634,
        longitude: -85.6681,
      },
      geoRadius: 50000,
    },
    paymentAccepted: ["Cash", "Credit Card", "Check"],
    currenciesAccepted: "USD",
    insuranceAccepted: "Through provider Frankenmuth Insurance",
    brand: {
      "@type": "Brand",
      name: "Roach Home Improvement",
    },
    founder: {
      "@type": "Person",
      name: "Roach Home Improvement Team",
    },
    memberOf: [
      { "@type": "Organization", name: "Better Business Bureau" },
      { "@type": "Organization", name: "National Kitchen and Bath Association" },
    ],
    makesOffer: {
      "@type": "Offer",
      name: "Free same-day roofing estimate",
      description: "Same-day comprehensive estimates",
      validFrom: "2025-07-01",
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
};

export default GrandRapidsSchema;
